/// <reference path="../../app.definition.ts" />

import angular from "angular";


export class SnackbarService {

    snacks: any = {
        VK_RESET_SUCCESS: {
            title: "Vault Key Reset Successfully",
            message: "You can now log in, enter your new Vault Key on the next screen, and continue using the application!",
            timeOut: 6000
        },
        VK_RESET_FAILURE: {
            title: "Oops! We ran into an issue trying to reset your Vault Key.",
            message: "Please click the link in your e-mail again or login and reset your Vault Key.",
            timeOut: 10000
        },
        VK_RESET_EXPIRED: {
            title: "Oops! Looks like this reset request has expired.",
            message: "Please log in to begin the reset process again.",
            timeOut: 10000
        },
        VK_RESET_USED: {
            title: "Oops! Looks like this reset request was already used.",
            message: "Please log in to begin the reset process again.",
            timeOut: 10000
        },
        VK_RESET_NO_INFO: {
            message: "Could not reset password due to missing or invalid information."
        },
        API_NOT_AVAILABLE: {
            message: "Oops! We seem to be having trouble communicating with our servers. Please try again soon!"
        }
    };
    snackbarObject: any = {};
    savedSnackbarObject: any = null;


    static $inject = ["$rootScope", "$location", "$_snackbar", "$timeout"];
    constructor(
        private $rootScope,
        private $location,
        private $_snackbar,
        private $timeout
    ) {

    }

    addSnackbarItem = (module, snack, onclickFunc) => {
        let tout = snack.timeOut || 0,
            pos = snack.position || 'toast-bottom-right',
            context = this;
        if (!this.snackbarObject[snack.notificationId]) {
            var onClose = function () {
                context.cleanup(snack.notificationId);
            };
            this.snackbarObject[snack.notificationId] = this.$_snackbar.info(snack.message, snack.title || '', {
                timeOut: tout,
                closeButton: true,
                positionClass: pos,
                extendedTimeOut: 0,
                hideDuration: 300,
                onclick: onclickFunc || null,
                onCloseClick: onClose,
                iconClass: 'ecv-toast-info ecv-toast-' + module + ' ' + snack.notificationId,
                containerId: 'toast-container-main'
            });
        
            //Open the notification tray
            this.$rootScope.toggleNotificationTray(true);
        }
    }

    //Hiding the notification tray if all toastrs are closed
    hideNotiTray = () => {
        if (Object.keys(this.snackbarObject).length == 0) {
            $('#ecv-notification-tray').addClass('ng-hide');
        }
    }

    cleanSnackbarObject = (notificationId) => {
        delete this.snackbarObject[notificationId];
        this.hideNotiTray();
    }

    cleanup = (notificationId) => {
        let toastrChildren = $('#toast-container-main').children();
        for (let i = 0; i < toastrChildren.length; i++) {
            let classList = Array.from(toastrChildren[i].classList);  
            
            if (!!this.snackbarObject[notificationId] && classList.includes(notificationId)) {
                toastr.clear($(toastrChildren[i]), {force:true});
                break;
            }
        }
        this.cleanSnackbarObject(notificationId);
    }


    clearNotificationToastr = (notificationId?) => {
        let toastrChildren = $('#toast-container-main').children();
        if (!!notificationId) {
            for (let i = 0; i < toastrChildren.length; i++) {
                let classList = Array.from(toastrChildren[i].classList);  
                
                if (!!this.snackbarObject[notificationId] && classList.includes(notificationId)) {
                    toastr.clear($(toastrChildren[i]), {force:true});
                    break;
                }
            }
            this.cleanSnackbarObject(notificationId);
        } else { //clear all
            for (let i = 0; i < toastrChildren.length; i++) {
                toastr.clear($(toastrChildren[i]), {force:true});
            }
            for (let p in this.snackbarObject) {
                delete this.snackbarObject[p];
            }
            this.hideNotiTray();
        }
    }

    removeSnackbar = (toastClass) => {
        $('.' + toastClass).each((t, obj) => {
            let toastId = $(obj).attr('id');
            !!toastId && this.clearNotificationToastr(toastId);
        });
    }

    showErrorToastr = (snack) => {
        let tout = snack.timeOut || 0,
            pos = snack.position || 'toast-top-full-width';
        this.$_snackbar.error(snack.message, snack.title || '', { positionClass: pos });
    }



    showDocDwnldToastr = (snack, onclickFunc) => {
        var context = this;
        let tout = snack.timeOut || 0,
            pos = snack.position || 'toast-bottom-right';

        if (!this.snackbarObject[snack.notificationId]) {
            this.snackbarObject[snack.notificationId] = this.$_snackbar.info(snack.message, snack.title || '', {
                timeOut: tout,
                positionClass: pos,
                extendedTimeOut: 0,
                hideDuration: 300,
                tapToDismiss: false,
                iconClass: 'ecv-toast-info ecv-toast-doc ' + snack.notificationId,
                closeButton: true,
                closeHtml: '<button><i class="fa fa-trash"></i></button>',
                onCloseClick: onclickFunc,
                containerId: 'toast-container-main'
            });
            //Open the notification tray
            this.$rootScope.toggleNotificationTray(true);
        }
    }

    showInvitationToastr = (snack, onclickFunc) => {
        let tout = snack.timeOut || 0,
            pos = snack.position || 'toast-bottom-right',
            context = this;
        if (!this.snackbarObject[snack.notificationId]) {
            var onClose = function () {
                context.cleanup(snack.notificationId);
            };
            this.snackbarObject[snack.notificationId] = this.$_snackbar.info(snack.message, snack.title || '', {
                timeOut: tout,
                closeButton: true,
                positionClass: pos,
                extendedTimeOut: 0,
                hideDuration: 300,
                onclick: onclickFunc || null,
                onCloseClick: onClose,
                iconClass: 'ecv-toast-info ecv-toast-team ' + snack.notificationId,
                containerId: 'toast-container-main'
            });
            //Open the notification tray
            this.$rootScope.toggleNotificationTray(true);
        }
    }


    checkForSnackbar(evt, to, params, from) {
        let locSrch = this.$location.search();
        let snackParam = locSrch.snackbar || params.snackbar || null;

        if (!!snackParam && !!this.snacks[snackParam]) {
            this.$timeout(() => {
                let snack = this.snacks[snackParam];
                if (!!snack.timeOut) {
                    this.$_snackbar.success(snack.message, snack.title || '', { timeOut: snack.timeOut });
                } else {
                    this.$_snackbar.success(snack.message, snack.title || '');
                }
            }, 0);
        }
    }
}
angular.module('eCareVault.common.services').service('SnackbarService', SnackbarService);
